<template>
  <tg-app-bar
    ref="appbar"
    :height="height"
    :size="size"
    :title="title"
    :type="type"
    prominent
    class="tg-app--header"
    @on-bars-click="handleBarsClick"
  >
    <tg-header-title
      :agent="agent"
      :member="member"
      :title="title"
      showOnline
      showLogo
      :site="site"
    >
      <slot></slot>
    </tg-header-title>
    <template slot="tools">
      <tg-toolbar-btn class="tg-app--btn" >
        <button class="user" @click="handleProfile"></button>
        <span @click="handleProfile">{{ user.username }}</span>
      </tg-toolbar-btn>
      <tg-toolbar-btn class="tg-app--btn is-disabled-hover">
        <button class="logout" @click="handleLogout"></button>
        <span>{{ $t("component.header.loginOut") }}</span>
      </tg-toolbar-btn>
    </template>
    <template v-slot:extension>
      <template>
        <tg-marquee :marquee="marquee"></tg-marquee>
      </template>
    </template>
  </tg-app-bar>
</template>

<script>
import TgAppBar from "@/components/bars/TgAppBar";
import TgHeaderTitle from "./TgHeaderTitle";
import TgToolbarBtn from "@/components/bars/TgToolbarBtn";
import TgMarquee from "@/components/marquee/TgMarquee";
import { headerProps } from "./utils";
export default {
  name: "TgHeader",
  components: {
    TgAppBar,
    TgHeaderTitle,
    TgToolbarBtn,
    TgMarquee,
  },
  props: headerProps,
  data() {
    return {
      showMarquee: false,
    };
  },
  methods: {
    handleLogout() {
      this.$emit("on-logout");
    },
    handleBarsClick(e) {
      this.$emit("on-bars-click", e);
    },
    handleProfile () {
      this.$emit("on-profile");
    }
  },
  watch: {
    $route() {
      this.showMarquee = this.$route.name == "dashboard";
      this.$nextTick(() => {
        this.$refs.appbar.parseExtendheight();
      });
    },
  },
};
</script>
